import { render } from "./CreateDocument.vue?vue&type=template&id=7abc8461"
import script from "./CreateDocument.vue?vue&type=script&lang=js"
export * from "./CreateDocument.vue?vue&type=script&lang=js"

import "./CreateDocument.vue?vue&type=style&index=0&id=7abc8461&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__